export default __webpack_public_path__ + "media/images/favicon-fc22c72bb68e5a52ff665ae8c42048d9.svg";